import { clsx, type ClassValue } from 'clsx';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import { twMerge } from 'tailwind-merge';

dayjs.extend(customParseFormat);

export const EMAIL_REGEX = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,8}$/;
export const PHONE_REGEX = /^\+?\d{8,}$/;
export const PASSWORD_REGEX = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z.*\W\d]{8,}$/; // min 8 chars, 1 uppercase, 1 lowercase, 1 number

export function cn(...inputs: ClassValue[]) {
    return twMerge(clsx(inputs));
}

export const normalizeArray = (arr: any) => {
    return arr?.edges?.map((item: any) => item.node) || [];
};

export const validateDate = (date: string) => {
    if (!date) return true;
    if (!dayjs(date, 'DD.MM.YYYY', true).isValid()) {
        return false;
    }
    return true;
};

/**
 * Safely convert a date from DD.MM.YYYY format to YYYY-MM-DD format for API calls.
 * Returns null for empty/invalid dates.
 */
export const convertDateToISO = (dateStr: string | undefined | null): string | null => {
    if (!dateStr || dateStr.trim() === '') return null;
    
    // Try parsing with explicit DD.MM.YYYY format (strict mode)
    const parsed = dayjs(dateStr, 'DD.MM.YYYY', true);
    if (parsed.isValid()) {
        return parsed.format('YYYY-MM-DD');
    }
    
    // Fallback: manually parse DD.MM.YYYY
    const parts = dateStr.trim().split('.');
    if (parts.length === 3) {
        const [day, month, year] = parts;
        const manualDate = dayjs(`${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`);
        if (manualDate.isValid()) {
            return manualDate.format('YYYY-MM-DD');
        }
    }
    
    return null;
};

/**
 * Convert a date from YYYY-MM-DD (ISO) format to DD.MM.YYYY for display.
 * Returns empty string for null/invalid dates.
 */
export const convertDateFromISO = (dateStr: string | undefined | null): string => {
    if (!dateStr) return '';
    const parsed = dayjs(dateStr);
    return parsed.isValid() ? parsed.format('DD.MM.YYYY') : '';
};

export const renderName = (contact: any) => {
    const { lastName, name } = contact;
    const arr = [lastName, name];
    return arr.filter(Boolean).join(', ');
};
